import moment from 'moment';

export const DATE_FORMATS = {
	DEFAULT: 'MM.DD.YYYY', // e.g., 12.31.2024
	ISO_DATE: 'YYYY-MM-DD', // e.g., 2024-12-31
	FULL_DATE: 'MMMM D, YYYY', // e.g., December 31, 2024
	FULL_DATE_TIME: 'MMMM Do YYYY [at] h:mm A', // e.g., December 31st 2024 at 5:00 PM
	FULL_DATE_TIME_ALT: 'MMM DD, YYYY, h:mm:ss A', // e.g., Dec 31, 2024, 5:00:00 PM
	SHORT_DATE: 'MMM Do YYYY', // e.g., Dec 31st 2024
	SHORT_DATE_ALT: 'MMM DD, YYYY', // e.g., Dec 31, 2024
	SHORT_DATE_TIME_ALT: 'MMM DD, YYYY, h:mm A', // e.g., Dec 31, 2024
	SHORT_DATE_AND_DAY_TIME: 'ddd, MMM DD, YYYY', // e.g., Tue, Dec 31, 2024
	SHORT_DATE_AND_FULL_TIME: 'MMM DD, YYYY [at] hh:mm', // e.g., Dec 31, 2024 at 5:00
	DOWNLOAD_DATE: 'DD-MM-YYYY', // e.g., 31-12-2024
	DAY_NAME: 'ddd', // e.g., Tue
	DAY_NAME_TIME: 'ddd h:mm A', // e.g., Tue 5:00 PM
	DAY_AND_MONTH: 'D MMMM', // e.g., 31 December
	MONTH_AND_DAY: 'MMMM D', // e.g., December 31
	DAY_AND_YEAR: 'MMM YYYY', // e.g., Dec 2024
	MONTH_AND_YEAR: 'MMMM YYYY', // e.g., December 2024
	DAY_NUMBER: 'D', // e.g., 31
	DAY_AND_DATE: 'ddd DD', // e.g., Mon 31
	DATE_WITH_FULL_MONTH_AND_YEAR: 'MMMM Do YYYY', // e.g., December 31st 2024
} as const;

export type DateFormat = (typeof DATE_FORMATS)[keyof typeof DATE_FORMATS];

export default function formatDate(date: moment.MomentInput, format: DateFormat | string = DATE_FORMATS.DEFAULT) {
	return moment(date).format(format);
}
